"use client";

import React from "react";
import { ShieldCheck, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  author: "Mark T.",
  quote: "\"They connected us with a top-tier specialist who fixed our damp crawl space. The referral process was incredibly fast and easy!\"",
  position: "Ankeny, IA"
}, {
  author: "Sarah L.",
  quote: "\"Finding a professional through this service was a lifesaver. The local contractor they recommended was professional and highly skilled.\"",
  position: "Urbandale, IA"
}, {
  author: "James R.",
  quote: "I was worried about moisture damage, but the expert they matched me with was thorough and the repair work they facilitated was top-notch.",
  position: "Waukee, IA"
}];
export default function WatchfulEyes() {
  return <section data-section-id="132780" id="local-success-stories" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none flex items-center justify-center z-0 opacity-40">
        <div className="absolute size-[250px] md:size-[400px] rounded-full border border-primary/10 animate-ping" style={{
        animationDuration: '6s'
      }} />
        <div className="absolute size-[350px] md:size-[600px] rounded-full border border-primary/5 animate-ping" style={{
        animationDuration: '6s',
        animationDelay: '1.5s'
      }} />
        <div className="absolute size-[450px] md:size-[800px] rounded-full border border-primary/5 animate-ping" style={{
        animationDuration: '6s',
        animationDelay: '3s'
      }} />
        
        {}
        <div className="absolute w-[120vw] h-px bg-primary/5" />
        <div className="absolute h-[120vh] w-px bg-primary/5" />
        
        {}
        <div className="absolute size-2 rounded-full bg-primary/20 shadow-[0_0_15px_var(--color-primary)]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-xs md:text-sm font-mono text-primary tracking-[0.2em] uppercase mb-2 flex items-center justify-center gap-3">
            <span className="size-1.5 bg-secondary rounded-sm animate-pulse" />
            Trusted Referral Success Stories
            <span className="size-1.5 bg-secondary rounded-sm animate-pulse" />
          </h2>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-4xl mx-auto px-12 md:px-16">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="md:basis-full">
                <div className="flex flex-col items-center text-center px-2 md:px-12 py-8 select-none">
                  <Quote className="size-10 md:size-14 text-chart-2/10 mb-8 rotate-180 drop-shadow-[0_0_10px_rgba(22,163,74,0.1)]" />
                  
                  <p className="font-sans font-bold text-2xl md:text-4xl lg:text-5xl text-foreground/90 tracking-tight leading-tight mb-12 max-w-3xl">
                    "{item.quote}"
                  </p>
                  
                  <div className="flex flex-col items-center gap-4">
                    <div className="flex flex-wrap items-center justify-center gap-3">
                      <span className="font-sans font-extrabold text-lg md:text-xl tracking-tight text-foreground">
                        {item.author}
                      </span>
                      <Badge variant="outline" className="border-chart-2/30 text-chart-2 bg-chart-2/5 gap-1.5 py-1 px-2.5 backdrop-blur-sm rounded-sm">
                        <ShieldCheck className="size-3.5" />
                        Expert Referral
                      </Badge>
                    </div>
                    <span className="text-muted-foreground text-xs md:text-sm uppercase tracking-widest font-mono font-medium">
                      {item.position}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <CarouselPrevious className="border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground bg-white/80 backdrop-blur-md size-10 md:size-12 -left-2 md:-left-6 transition-all duration-300 shadow-sm hover:shadow-md rounded-sm" />
          <CarouselNext className="border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground bg-white/80 backdrop-blur-md size-10 md:size-12 -right-2 md:-right-6 transition-all duration-300 shadow-sm hover:shadow-md rounded-sm" />
        </Carousel>
      </div>
    </section>;
}